class SliderSteps {
	constructor(element) {
		this.currentStep = 0;
		this.stepsToShow = 3.5; // Show 3 full and part of the 4th
		this.wrapper = element.querySelector(".slider-steps__wrapper");
		this.steps = element.querySelectorAll(".slider-steps__step");
		this.stepWidth = 460 + 20; // Step width (460px) + gap (20px)
		this.totalSteps = this.steps.length;
		this.prevButton = element.querySelector(".slider-steps__controls button.prev");
		this.nextButton = element.querySelector(".slider-steps__controls button.next");

		if (!this.wrapper || !this.steps.length) return; // Ensure elements exist

		this.init();
	}

	init() {
		this.steps[this.currentStep].classList.add("active");
		this.updateButtonState();
		this.setupEventHandlers();
	}

	updateSliderPosition() {
		const container = this.wrapper.closest(".slider-steps__container");
		const containerWidth = container.offsetWidth;

		let maxVisibleSteps = Math.floor(containerWidth / this.stepWidth);
		let visibleRightEdge = (this.currentStep + maxVisibleSteps) * this.stepWidth;

		if (visibleRightEdge >= this.totalSteps * this.stepWidth) {
			this.wrapper.style.transform = `translateX(-${(this.totalSteps - maxVisibleSteps) * this.stepWidth}px)`;
			this.nextButton.disabled = true;
		} else {
			this.wrapper.style.transform = `translateX(-${this.currentStep * this.stepWidth}px)`;
			this.nextButton.disabled = false;
		}
	}

	setActiveStep(index) {
		this.steps.forEach(step => step.classList.remove("active"));

		this.currentStep = index;
		this.steps[this.currentStep].classList.add("active");

		this.steps.forEach((step, idx) => {
			if (idx < this.currentStep) {
				step.classList.add("completed");
			} else {
				step.classList.remove("completed");
			}
		});

		this.updateButtonState();
	}

	moveStep(direction) {
		if (direction > 0) {
			const container = this.wrapper.closest(".slider-steps__container");
			const containerWidth = container.offsetWidth;
			let maxVisibleSteps = Math.floor(containerWidth / this.stepWidth);
			let nextIndex = this.currentStep + maxVisibleSteps;

			if (nextIndex >= this.totalSteps) {
				nextIndex = this.totalSteps - maxVisibleSteps;
			}

			this.currentStep = nextIndex;
			this.updateSliderPosition();
			this.updateButtonState();
		} else {
			const container = this.wrapper.closest(".slider-steps__container");
			const containerWidth = container.offsetWidth;
			let maxVisibleSteps = Math.floor(containerWidth / this.stepWidth);
			let prevIndex = this.currentStep - maxVisibleSteps;

			if (prevIndex < 0) {
				prevIndex = 0;
			}

			this.currentStep = prevIndex;
			this.updateSliderPosition();
			this.updateButtonState();
		}
	}

	updateButtonState() {
		this.prevButton.disabled = this.currentStep === 0;
		this.nextButton.disabled = this.currentStep === this.totalSteps - 1;
	}

	setupEventHandlers() {
		this.prevButton.addEventListener("click", () => this.moveStep(-1));
		this.nextButton.addEventListener("click", () => this.moveStep(1));

		this.steps.forEach((step, index) => {
			step.addEventListener("click", () => {
				const container = this.wrapper.closest(".slider-steps__container");
				const containerRect = container.getBoundingClientRect();
				const stepRect = step.getBoundingClientRect();

				const isPartiallyVisible = stepRect.right > containerRect.right;

				if (isPartiallyVisible) {
					this.moveStep(1);
				} else {
					this.setActiveStep(index);
				}
			});

			step.addEventListener("mouseenter", () => {
				this.steps.forEach((s, i) => {
					s.classList.remove("active", "completed");
					if (i < index) s.classList.add("completed");
					if (i === index) s.classList.add("active");
				});
			});

			step.addEventListener("mouseleave", () => {
				this.steps.forEach((s, i) => {
					s.classList.remove("active", "completed");
					if (i < this.currentStep) s.classList.add("completed");
					if (i === this.currentStep) s.classList.add("active");
				});
			});
		});

		this.setupSwipeHandlers();
	}

	setupSwipeHandlers() {
		let touchStartX = 0;
		let touchEndX = 0;
		let isSwiping = false;
		let startTranslate = 0;

		this.wrapper.addEventListener("touchstart", (event) => {
			touchStartX = event.touches[0].clientX;
			startTranslate = this.currentStep * this.stepWidth;
			isSwiping = true;
		});

		this.wrapper.addEventListener("touchmove", (event) => {
			if (!isSwiping) return;
			touchEndX = event.touches[0].clientX;
			let moveDistance = touchStartX - touchEndX;
			this.wrapper.style.transform = `translateX(-${startTranslate + moveDistance}px)`;
		});

		this.wrapper.addEventListener("touchend", () => {
			let swipeDistance = touchStartX - touchEndX;
			isSwiping = false;

			const swipeThreshold = 50;

			if (swipeDistance > swipeThreshold) {
				this.moveStep(1);
			} else if (swipeDistance < -swipeThreshold) {
				this.moveStep(-1);
			} else {
				this.wrapper.style.transform = `translateX(-${this.currentStep * this.stepWidth}px)`;
			}
		});
	}
}

// Initialize the slider when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
	const sliderElement = document.querySelector('.slider-steps');
	new SliderSteps(sliderElement);
});

export default SliderSteps;